import { LICENSE_MODULES, ROLES } from '../../../../../constants';

import ViewUserPermissions from '../../v2/components/view/permissions/permissions-users';
import ViewTeamPermissions from '../../v2/components/view/permissions/permissions-teams';
import ViewPermissionsDetails from '../../v2/components/view/permissions/permissions-details';
import ViewStructure from '../../v2/components/view/structure/structure';

export default [
  {
    path: '/view/user-permissions',
    name: 'view-user-permissions',
    component: ViewUserPermissions,
    meta: {
      title: 'User Permissions',
      requiresAuth: true,
      modules: [LICENSE_MODULES.VIEW],
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
    },
  },
  {
    path: '/view/team-permissions',
    name: 'view-team-permissions',
    component: ViewTeamPermissions,
    meta: {
      title: 'Team Permissions',
      requiresAuth: true,
      modules: [LICENSE_MODULES.VIEW],
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
    },
  },
  {
    path: '/view/permissions-details/:userId',
    name: 'view-permissions-details',
    component: ViewPermissionsDetails,
    meta: {
      title: 'Permissions',
      requiresAuth: true,
      modules: [LICENSE_MODULES.VIEW],
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
    },
  },
  {
    path: '/view/team-permissions-details/:teamId',
    name: 'view-team-permissions-details',
    component: ViewPermissionsDetails,
    meta: {
      title: 'Permissions',
      requiresAuth: true,
      modules: [LICENSE_MODULES.VIEW],
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
    },
  },
  {
    path: '/view/structure',
    name: 'view-structure',
    component: ViewStructure,
    meta: {
      title: 'Structure',
      requiresAuth: true,
      modules: [LICENSE_MODULES.VIEW],
      roles: [ROLES.SUPERADMIN, ROLES.ADMIN],
    },
  },
];
